import { useTheme } from '../../contexts/ThemeContext';
import SectionCard from '../ui/SectionCard';
import BaseSkeleton from '../ui/Skeleton';
import { DataSurface, DataTable, DataTableCell, DataTableHeadCell, DataTableRow } from '../ui/dataSurface';

const Skeleton = (props) => <BaseSkeleton {...props} style={{ backgroundColor: 'var(--color-border)' }} />;

export const AccountsListSkeleton = () => {
  const { preference } = useTheme();
  const isLight = preference === 'light';
  return (
    <DataSurface as="div" data-testid="accounts-list-skeleton" variant="comfortable" className="overflow-hidden rounded-xl" aria-hidden="true">
      <div className="space-y-5 p-5">
        <div className={`rounded-xl ${isLight ? 'border border-[var(--color-tile-border)] bg-[var(--color-surface)] shadow-[var(--shadow-surface)]' : 'bg-[var(--color-surface-input)]'}`}>
          <div className="flex items-center justify-between gap-4 border-b border-[var(--color-data-divider)] px-5 py-4">
            <div className="min-w-0">
              <Skeleton className="h-6 w-44 max-w-full rounded-full" />
              <div className="mt-1 flex flex-wrap items-center gap-3">
                <Skeleton className="h-4 w-36 rounded-full" />
                <Skeleton className="h-6 w-24 rounded-full" />
              </div>
            </div>
            <Skeleton className="h-10 w-32 shrink-0 rounded-xl" />
          </div>
          <div className="overflow-x-auto">
            <DataTable density="comfortable" className="min-w-[760px]">
              <thead>
                <tr>
                  <DataTableHeadCell density="comfortable">Account</DataTableHeadCell>
                  <DataTableHeadCell density="comfortable">Type</DataTableHeadCell>
                  <DataTableHeadCell density="comfortable" align="right">Balance</DataTableHeadCell>
                  <DataTableHeadCell density="comfortable" align="right">Net Worth</DataTableHeadCell>
                </tr>
              </thead>
              <tbody>
                {[0, 1, 2].map(index => (
                  <DataTableRow key={index} density="comfortable">
                    <DataTableCell density="comfortable"><Skeleton className="h-5 w-40 max-w-full rounded-full" /></DataTableCell>
                    <DataTableCell density="comfortable">
                      <Skeleton className="h-5 w-24 rounded-full" />
                      <Skeleton className="mt-1 h-4 w-12 rounded-full" />
                    </DataTableCell>
                    <DataTableCell density="comfortable" align="right"><Skeleton className="ml-auto h-5 w-20 rounded-full" /></DataTableCell>
                    <DataTableCell density="comfortable" align="right"><Skeleton className="ml-auto h-11 w-24 rounded-xl" /></DataTableCell>
                  </DataTableRow>
                ))}
              </tbody>
            </DataTable>
          </div>
        </div>
      </div>
    </DataSurface>
  );
};

const AccountsLoadingSkeleton = () => {
  const { preference } = useTheme();
  return (
    <SectionCard data-testid="accounts-content-skeleton" className="p-8" aria-hidden="true">
      <div className="mb-6" />
      <div data-testid="accounts-summary-skeleton" className={`mb-6 min-h-[112px] rounded-xl p-6 ${preference === 'light' ? 'border border-[var(--color-tile-border)] bg-[var(--color-surface)] shadow-[var(--shadow-surface)]' : 'bg-[var(--color-surface-input)]'}`}>
        <Skeleton className="mb-5 h-5 w-36 rounded-full" />
        <Skeleton className="h-4 w-48 max-w-full rounded-full" />
      </div>
      <AccountsListSkeleton />
    </SectionCard>
  );
};

export default AccountsLoadingSkeleton;
